var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-6 pa-6"},[_vm._v(" Featured Creators ")])
}
var staticRenderFns = []

export { render, staticRenderFns }